import React from 'react';
import { useParams } from 'react-router-dom';
import { Col, Flex, Row, Skeleton } from 'antd';
import { DefaultPageLayout } from 'layouts/default-page-layout';
import { useGetOrder } from 'api/orders/use-get-order.ts';
import type { ClientRes } from 'api/swagger';
import { ECommentEntityName } from 'types/comment.ts';
import { ClientInfoCard } from 'components/clients/client-info-card';
import { CommentsCard } from 'components/comments/comments-card';
import { OrderInfoCard } from 'components/orders/order-info-card';
import { OrderMain } from 'components/orders/order-main';
import { OrderPageHeader } from 'components/orders/order-page-header';

export const OrderPage: React.FC = () => {
  const { orderId } = useParams();

  const { data: order, isLoading } = useGetOrder(Number(orderId));

  return (
    <DefaultPageLayout header={!isLoading && order ? <OrderPageHeader order={order} /> : undefined}>
      {!isLoading && order ? (
        <>
          <Row gutter={16}>
            <Col span={17}>
              <OrderMain orderId={order.id} />
            </Col>
            <Col span={7}>
              <Flex gap='middle' vertical>
                <OrderInfoCard order={order} client={order.client as ClientRes} />
                <ClientInfoCard client={order.client as ClientRes} contact={order.contact} />
                <CommentsCard entityName={ECommentEntityName.order} entityId={order.id} />
              </Flex>
            </Col>
          </Row>
        </>
      ) : (
        <Skeleton />
      )}
    </DefaultPageLayout>
  );
};
